// extracted by mini-css-extract-plugin
module.exports = {"skuDisclaimer":"addskudisclaimer_skuDisclaimer__R2POz","fadein":"addskudisclaimer_fadein__Mvj1r","loading":"addskudisclaimer_loading__UYlck"};